export default __webpack_public_path__ + "static/media/empty-do_2.c69f16b8.png";